// Lenis-aware smooth scroll helper. Falls back to native when lenis is absent
// or the user prefers reduced motion.
export function scrollToTarget(target, { offset = -80 } = {}) {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(target, { offset, duration: 1.1 });
    return;
  }
  const el =
    typeof target === "string"
      ? document.querySelector(target.startsWith("#") ? target : `#${target}`)
      : target;
  if (el && el.scrollIntoView) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

export function scrollTop() {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(0, { immediate: true });
    return;
  }
  window.scrollTo(0, 0);
}
